import {
  Link, Paper, Table, TableBody, TableCell, TableRow,
} from '@mui/material';
import * as React from 'react';

import type { TranscriptionResponseDTO } from '@klangio/ai2notes-ts-client';
import { safeJSONParse } from '../../utils';

export interface AdminDetailsProps {
  transcription: TranscriptionResponseDTO;
}

const AdminDetails: React.FC<AdminDetailsProps> = ({ transcription }) => {
  const formatJsonValue = (value: any) => {
    return JSON.stringify(safeJSONParse(value), null, 2);
  };

  return (
    <Paper>
      <div>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <strong>File Link</strong>
              </TableCell>
              <TableCell>
                <Link href={`/file?id=${transcription.id}`}>View File</Link>
              </TableCell>
            </TableRow>
            {Object.entries(transcription).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell>
                  <strong>{key}</strong>
                </TableCell>
                <TableCell>
                  {key === 'parameters' ? (
                    <code style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>
                      {formatJsonValue(value)}
                    </code>
                  ) : (
                    <>{JSON.stringify(value)}</>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Paper>
  );
};

export default AdminDetails;
